<!-- <div *ngIf="this.loader.getLoading()" class="cssload-container">
  <div class="cssload-speeding-wheel"></div>
</div> -->

<div *ngIf="this.loader.getLoading()" class="cssload-container">
  <img src="assets/img/looms-spinner.png" class="cssload-spinner" alt="Loading...">
</div>
